import { Save, CheckCircle2, AlertCircle } from "lucide-react";

/** Save/Cancel button row with an inline status message. */
export function FormActions({
    saving,
    status,
    error,
    successLabel = "Modifications enregistrées.",
    saveLabel = "Enregistrer",
    onCancel,
    testId = "form",
    disabled = false,
}) {
    return (
        <div className="mt-6 flex items-center gap-4 flex-wrap">
            <button
                type="submit"
                disabled={saving || disabled}
                className="btn-gold"
                data-testid={`${testId}-save-btn`}
            >
                <Save size={14} />
                {saving ? "Enregistrement…" : saveLabel}
            </button>
            {onCancel && (
                <button
                    type="button"
                    onClick={onCancel}
                    className="text-sm text-neutral-400 hover:text-neutral-100 px-3 py-2 border border-ink-border hover:border-ink-borderStrong transition-colors"
                    data-testid={`${testId}-cancel-btn`}
                >
                    Annuler
                </button>
            )}
            {status === "success" && (
                <span
                    className="text-sm text-emerald-300 inline-flex items-center gap-2"
                    data-testid={`${testId}-success`}
                >
                    <CheckCircle2 size={16} /> {successLabel}
                </span>
            )}
            {status === "error" && (
                <span
                    className="text-sm text-red-300 inline-flex items-center gap-2"
                    data-testid={`${testId}-error`}
                >
                    <AlertCircle size={16} /> {error || "Erreur — vérifiez et réessayez."}
                </span>
            )}
        </div>
    );
}

/** Section wrapper card for admin editors. */
export function SectionCard({ title, description, children, testId }) {
    return (
        <section
            data-testid={testId}
            className="card-line p-6 md:p-8 mb-6"
        >
            <div className="mb-6">
                <h2 className="font-serif text-2xl text-neutral-50 mb-2">
                    {title}
                </h2>
                {description && (
                    <p className="text-sm text-neutral-400 leading-relaxed max-w-2xl">
                        {description}
                    </p>
                )}
            </div>
            {children}
        </section>
    );
}

/** Page header used at the top of each admin page. */
export function AdminPageHeader({ title, subtitle }) {
    return (
        <header className="mb-8" data-testid="admin-page-header">
            <div className="eyebrow mb-3">
                <span className="gold-rule mr-3" />
                Administration
            </div>
            <h1 className="font-serif text-3xl md:text-4xl text-neutral-50 leading-tight">
                {title}
            </h1>
            {subtitle && (
                <p className="mt-2 text-sm text-neutral-400 max-w-2xl leading-relaxed">
                    {subtitle}
                </p>
            )}
        </header>
    );
}
